export default __webpack_public_path__ + "static/media/blueslider3.3171ec07.png";